import { render } from "./ClientSelection.vue?vue&type=template&id=adaa25b2&scoped=true"
import script from "./ClientSelection.vue?vue&type=script&lang=js"
export * from "./ClientSelection.vue?vue&type=script&lang=js"

import "./ClientSelection.vue?vue&type=style&index=0&id=adaa25b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adaa25b2"]])

export default __exports__